import { Box, Button } from '@mui/material';
import { useAccount } from '../../contexts/Account';

function step5() {
  const { currentPlan } = useAccount();

  return (
    <Box
      sx={{
        height: '100vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        padding: { xxs: '24px', xs: '0px' },
      }}
    >
      <iframe
        src="https://cdn.advisorycloud.com/static-content/loading-v2.html"
        title="Loading Profile"
        frameBorder="0"
        style={{
          width: '100%',
          height: '400px',
          overflowX: 'visible',
          marginBottom: '80px',
        }}
      />
      <Button
        id="company-onboarding-step-5"
        type="button"
        variant="contained"
        color="primary"
        onClick={() => {
          window.location.replace(currentPlan.onboardingRedirectUrl);
        }}
        sx={{
          borderRadius: '50px',
          backgroundColor: '#3171F6',
          '&:hover': { backgroundColor: '#3171F6' },
          height: '48px',
          textTransform: 'none',
          fontSize: '16px',
          fontWeight: 700,
          width: { xxs: '100%', xs: '340px' },
        }}
      >
        Enter Boardroom & Invite People
      </Button>
    </Box>
  );
}

export default step5;
